import { Constraints, Platform } from '@fullstory/proto/fs/api/segment';
import { Duration } from '@fullstory/proto/google/protobuf';

export const MIN_FUNNEL_EVENT_FILTERS = 2;

export const DEFAULT_FUNNEL_CONSTRAINTS: Constraints = {
  inOrder: true,
  inSameSession: true,
  platform: Platform.PLATFORM_INVALID,
  timeRange: null,
  completeSessions: false,
  withinTime: Duration.zero,
  eventThresholds: [],
};
